import { render, staticRenderFns } from "./Aggrid.vue?vue&type=template&id=7936314e"
import script from "./Aggrid.vue?vue&type=script&lang=js"
export * from "./Aggrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports